sc_llid